import { CatalogStore } from "../../store/modules/catalog";
import { BankProductData } from "../../data/bankProductData";
import { Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

export class BankProductsVue extends Vue {

  // stores: 

  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  // computed:

  get products(): Array<BankProductData> {
    return this.catalogStore.bankProducts;
  }

  // methods:

  // async init(): Promise<void> {
  //   try {
  //     if (this.products.length > 0) 
  //       return;
  //     const resp: any = await ConfigApi.getBankProducts();
  //     let products: Array<BankProductData> = [];

  //     for (const key in resp.data?.Data?.InnerData?.Data) {
  //       const product: any = resp.data?.Data?.InnerData?.Data[key];

  //       if (product) {

  //         products.push(new BankProductData(product.Properties, product.InnerData?.Data?.detailNames?.Properties));

  //         const lastAddedProduct: BankProductData = products[products.length-1];

  //         if (lastAddedProduct.ViewName === 'depositTypesList') {

  //           for (const i in product.InnerData?.Data?.childs?.InnerData?.Data) {

  //             const deposit: any = product.InnerData?.Data?.childs?.InnerData?.Data[i];

  //             lastAddedProduct.Childs.push(new DepositData(deposit.Properties));

  //             for (const j in deposit.InnerData?.Data) {

  //               const currDepo: any = deposit.InnerData?.Data[j];

  //               lastAddedProduct.Childs[lastAddedProduct.Childs.length - 1].CurrencyChilds.push(
  //                 new DepositCurrencyTypeData(currDepo.Properties, currDepo.InnerData?.Data?.initData?.Properties)
  //               );

  //             }

  //             lastAddedProduct.Childs[lastAddedProduct.Childs.length - 1].ActiveCurrency = 
  //               lastAddedProduct.Childs[lastAddedProduct.Childs.length - 1].CurrencyChilds[0].currency;

  //             lastAddedProduct.Childs[lastAddedProduct.Childs.length - 1].ActiveTerm = 
  //               lastAddedProduct.Childs[lastAddedProduct.Childs.length - 1].CurrencyChilds[0].term;

  //           }

  //         }

  //       }
  //     }

  //     this.configStore.setBankProducts(products);

  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  goTo(product: BankProductData): void {
    if (product.OperId) {
      this.$router.push(`/operation/0/${product.OperId}`);
    } else if (product.ViewName) {
      this.$router.push(`/${product.ViewName}`);
    }
  }

}
